import React from 'react';

// Parses time format coming from Timestream into seconds
export function parseTime(t: string): number | string {
  if (!t) {
    return "-"
  }

  // Format: 0 00:00:00.249000000
  const [days, r] = t.split(" ");
  const [hours, minutes, s] = r.split(":");
  const [seconds, nanoseconds] = s.split(".");

  return (Number(nanoseconds) / 1000000000 + Number(seconds) * 1 + Number(minutes) * 60 + Number(hours) * 3600 + Number(days) * 86400).toFixed(3);
}

// Helper function to highlight search terms in text
export const highlightText = (text: string, searchTerm: string) => {
  if (!searchTerm || !text) return text;

  const parts = String(text).split(new RegExp(`(${searchTerm})`, 'gi'));

  return (
    <>
      {parts.map((part, i) => 
        part.toLowerCase() === searchTerm.toLowerCase() 
          ? <span key={i} style={{ backgroundColor: 'yellow', fontWeight: 'bold' }}>{part}</span> 
          : part
      )}
    </>
  );
};